module.exports = __webpack_public_path__ + "img/B.4f3e80e5.png";